export default __webpack_public_path__ + "static/media/Board2_Preview_Transparent.76223d65.png";